export class LocationPrijsmodule {
  constructor() {
    this.$prijsmoduleButtonBestMatch = $('.vestiging-prijsmodule .prijsmodule-form-gf-form input[type="submit"]');
    this.$prijsmoduleButtonDirectContact = $('.vestiging-prijsmodule .prijsmodule-results-item-link');
    this.$prijsmoduleButtonModal = $('.prijsmodule-results-modal');
    this.$prijsmoduleResults = $('.prijsmodule-results');
    this.$prijsmoduleResultsDots = $('.prijsmodule-results-dots span');

    // bind events
    $(window).on('load', () => this.inactiveTooltip());
    this.$prijsmoduleButtonBestMatch.on('click', e => this.showResults(e));
    this.$prijsmoduleButtonDirectContact.on('click', e => this.showDirectContact(e));
    this.$prijsmoduleButtonModal.on('click', () => this.showModal('.hwb_pakketten'));
    this.$prijsmoduleResults.on('scroll', e => this.scrollResultsHorizontal(e));
    this.$prijsmoduleResultsDots.on('click', e => this.scrollResultsToItem(e));
  }

  /*
   *  Prijsmodule functions
   */
  inactiveTooltip(){
    if (($('#prijsmodule-item-rem').hasClass('item-inactive'))
      && ($('#prijsmodule-item-bas-1').hasClass('item-inactive'))) {
      const prijsmoduleVragenSchool = $('.vragen_school_field input:radio');
      const prijsmoduleBasisschoolTooltip = $('#prijsmodule-basisschool-tooltip');
      const prijsmoduleVragenSubmit = $('.prijsmodule-form-vragen #field_submit input');
      prijsmoduleVragenSchool
        .filter('[value="basis"]').prop('disabled',true)
        .next('label').addClass('radio_choice_disabled')
        .append('<i class="fa-light fa-circle-info" id="prijsmodule-basisschool-tooltip-icon"></i>');
      prijsmoduleVragenSchool
        .filter('[value="middel"]').prop('checked', true);
      prijsmoduleBasisschoolTooltip.detach().appendTo('.radio_choice_disabled');
      this.showTooltip(prijsmoduleBasisschoolTooltip, '#prijsmodule-basisschool-tooltip-icon');
      prijsmoduleVragenSubmit.show().removeAttr('disabled').attr('data-conditional-logic', 'visible');
    }
  }

  showResults(e) {
    e.preventDefault();
    this.showTooltip($('#prijsmodule-hwb-basis-tooltip-content'), '#prijsmodule-hwb-basis-tooltip-icon');
    this.showTooltip($('#prijsmodule-hwb-standaard-tooltip-content'), '#prijsmodule-hwb-standaard-tooltip-icon');
    this.showTooltip($('#prijsmodule-hwb-plus-tooltip-content'), '#prijsmodule-hwb-plus-tooltip-icon');
    this.defineBestMatch();

    const vragenSchool = $('.vragen_school_field').find(':checked').val();
    const bestMatchElement = $('.best-match');
    const prijsmoduleResultsWrapper = $('.prijsmodule-results-wrapper');
    const prijsmoduleResultsHwbWrapper = $('.prijsmodule-results-hwb-wrapper');
    const prijsmoduleResultsBijlesMiddelWrapper = $('.prijsmodule-results-bijles-middel-wrapper');
    const prijsmoduleResultsBijlesBasisWrapper = $('.prijsmodule-results-bijles-basis-wrapper');
    const prijsmoduleResultsHwb = $('.prijsmodule-results-hwb');
    const headerHeight = $('.main-header').height();
    const topBarHeight = $('.vestigingspagina_top_bar_wrapper').height();

    prijsmoduleResultsWrapper.show('slow');
    $([document.documentElement, document.body]).animate({
      scrollTop: prijsmoduleResultsWrapper.offset().top - headerHeight - topBarHeight + 10,
    },
    1000);
    if ( vragenSchool === 'middel') {
      prijsmoduleResultsHwbWrapper.show('slow');
      prijsmoduleResultsBijlesMiddelWrapper.show('slow');
      prijsmoduleResultsBijlesBasisWrapper.hide();
      prijsmoduleResultsHwb.animate({
        scrollLeft: bestMatchElement.position().left + prijsmoduleResultsHwb.scrollLeft(),
      },
      1000);
    } else {
      prijsmoduleResultsHwbWrapper.hide();
      prijsmoduleResultsBijlesMiddelWrapper.hide();
      prijsmoduleResultsBijlesBasisWrapper.show('slow');
    }
  }

  defineBestMatch() {
    const vragenSchool = $('.vragen_school_field').find(':checked').val();
    const isHwb4 = $('#prijsmodule-item-hwb-4').hasClass('item-active');
    const isHwb5 = $('#prijsmodule-item-hwb-5').hasClass('item-active');
    const isHwb6 = $('#prijsmodule-item-hwb-6').hasClass('item-active');
    let bestMatch;
    if ( vragenSchool === 'middel') {
      if (isHwb6) {
        bestMatch = 'hwb-6';
      } else if (isHwb5) {
        bestMatch = 'hwb-5';
      } else if (isHwb4) {
        bestMatch = 'hwb-4';
      }
    }
    $('.prijsmodule-results-item').removeClass('best-match');
    $('#prijsmodule-item-'+bestMatch).addClass('best-match');
  }

  scrollResultsHorizontal(e) {
    const parentResult = $(e.currentTarget);
    const items = parentResult.children('.prijsmodule-results-item');
    const parentScrollLeft = parentResult.scrollLeft();
    const parentWidth = parentResult.outerWidth();

    const centerPosition = parentScrollLeft + parentWidth / 2;

    let closestItem = null;
    let closestDistance = Infinity;

    items.each(function() {
      const item = $(this);
      const itemLeft = item.position().left + parentScrollLeft;
      const itemRight = itemLeft + item.outerWidth();
      const itemCenter = (itemLeft + itemRight) / 2;
      const distance = Math.abs(centerPosition - itemCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });

    if (closestItem) {
      const itemId = closestItem.attr('id');
      const correspondingDot = $('.prijsmodule-results-dots').find(`[data-item='${itemId}']`);
      correspondingDot.siblings('.dot_active').removeClass('dot_active').addClass('dot_inactive');
      correspondingDot.removeClass('dot_inactive').addClass('dot_active');
    }
  }

  scrollResultsToItem(e) {
    const dataItem = $(e.currentTarget).attr('data-item');
    const targetElement = $('#'+dataItem);
    const parentResult = $(e.currentTarget).parent('.prijsmodule-results-dots').prev('.prijsmodule-results');
    parentResult.animate({
      scrollLeft: targetElement.position().left + parentResult.scrollLeft(),
    },
    1000);
  }

  showDirectContact(e) {
    e.preventDefault();
    const gekozen_dienst = $(e.currentTarget).attr('data-product');
    const dienst_skoleo = $(e.currentTarget).attr('data-product-skoleo');
    const gekozen_tarief = $(e.currentTarget).attr('data-item');
    const prijsmoduleFormContact = $('.prijsmodule-form-contact');
    $('.gekozen_dienst_field input').val(gekozen_dienst).attr('readonly','readonly');
    $('.gekozen_dienst_skoleo_field input').val(dienst_skoleo);
    $('.gekozen_tarief_field input').val(gekozen_tarief);
    if ( $(e.currentTarget).parent('.prijsmodule-results-item').hasClass('best-match') ) {
      $('.best_match_field input').val(' De beste match werd gekozen!');
    } else {
      const best_match_item = $('.best-match a.prijsmodule-results-item-link').attr('data-item');
      $('.best_match_field input').val(' De beste match was '+best_match_item+' en werd niet gekozen.');
    }
    prijsmoduleFormContact.show('slow').css('display', 'grid');
    const headerHeight = $('.main-header').height();
    const topBarHeight = $('.vestigingspagina_top_bar_wrapper').height();
    $([document.documentElement, document.body]).animate({
      scrollTop: prijsmoduleFormContact.offset().top - headerHeight - topBarHeight,
    },
    1000);
  }

  showTooltip(tooltipContent, tooltipIconId) {
    let tooltipVisible = false;
    const tooltipIcon = $(tooltipIconId);
    tooltipIcon
      .on('click mouseenter', function(event){
        tooltipContent.show();
        tooltipVisible = true;
        event.stopPropagation();
      })
      .on('mouseleave', function(){
        tooltipContent.hide();
        tooltipVisible = false;
      });
    $('body').on('click', function(){
      if ( tooltipVisible ) {
        tooltipContent.hide();
        tooltipVisible = false;
      }
    });
  }

  showModal(modalClass){
    $(modalClass).modal('show');
  }
}
